export enum MessagesErrors {
  RESEND_FAILED = 'Failed to resend message',
  SEND_FAILED = 'Failed to send message',
  EDIT_FAILED = 'Failed to edit message',
  DELETE_FAILED = 'Failed to delete message',
  ADD_ATTACHMENTS_FAILED = 'Failed to add attachments',
  FETCH_FAILED = 'Failed to fetch message',
  CANNOT_EDIT_SENT_MESSAGE = 'You cannot edit messages that have already been sent',
  ALREADY_SENT = 'This message is already marked as sent',
}
